import { InspectionClient, NavigatorImagesResponseDTO } from 'business/models/Models';
import BaseService from './BaseService';
import ModelFactory from 'business/models/ModelFactory';

export default class InspectionService extends BaseService {
  async GetNavigatorImages(
    expId: number,
    plateId: number,
    wellNum: number,
    batchId: number,
    cpId: number,
    dropNum: number,
    regionName: string,
  ): Promise<NavigatorImagesResponseDTO> {
    const insp: InspectionClient = ModelFactory(InspectionClient, false, true);
    const navigatorImages = await insp.getNavigatorImages(
      expId,
      plateId,
      wellNum,
      batchId,
      cpId,
      dropNum,
      regionName,
    );
    return navigatorImages;
  }
}
